import React from 'react'
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts'

import { Page } from '../../../components/layouts/page'
import { Column } from '../../../components/layouts/columns'
import { Icon } from '../../../components/icons'
import { Select } from '../../../components/ui/select'
import { Input } from '../../../components/ui/input'
import { useClientEventReports } from './_hooks/useClientEventReports'
import { TransformationforMask } from '../../../utils/masks'
// import { TransformationforMask } from '../../../utils/masks'

export const ClientEventReports = () => {
  const {
    formContext,
    filters,
    setFilters,
    candidacyHistory,
    rounds,
    dates,
    jobs,
    reportStatusPerJobOffer,
    reportStatusPerJobOfferTotal,
    statusStaff,
  } = useClientEventReports()

  return (
    <Page.Section className="is-fullheight-with-navbar">
      {/* Header */}
      <Column.Root>
        <Column.Content>
          <p className="subtitle is-size-4">
            <Icon size={30} className="mr-3">
              comparison
            </Icon>
            Relatórios do Evento
          </p>
        </Column.Content>
      </Column.Root>

      <Column.Root>
        <Column.Content>
          <p className="subtitle has-text-grey-light">{TransformationforMask(formContext?.name, 'title')}</p>
        </Column.Content>
      </Column.Root>

      {/* Seções de relatório */}
      <div className="box mt-4 mb-6">
        <p className="subtitle is-size-5">Histórico de candidaturas</p>
        <div style={{ width: '100%', height: 300 }}>
          <ResponsiveContainer>
            <LineChart data={candidacyHistory || []}>
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip
                contentStyle={{
                  backgroundColor: '#fff', // fundo opaco
                  border: '1px solid #ccc',
                  borderRadius: '6px',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                  color: '#333',
                }}
                wrapperStyle={{
                  zIndex: 1000, // garante que fica acima do gráfico
                }}
              />
              <Line
                type="monotone"
                dataKey="staff"
                name="Candidaturas Registradas"
                stroke="#1b2027ff"
                strokeWidth={2}
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* Filtros */}
      <Column.Root>
        <Column.Content>
          <Input.Root>
            <Input.Label>Data</Input.Label>
            <Select.Root>
              <Select.Search options={dates || []} value={filters} setValue={setFilters} field="date" />
            </Select.Root>
          </Input.Root>
        </Column.Content>

        <Column.Content>
          <Input.Root>
            <Input.Label>Turno</Input.Label>
            <Select.Root>
              <Select.Search options={rounds || []} value={filters} setValue={setFilters} field="round" />
            </Select.Root>
          </Input.Root>
        </Column.Content>

        <Column.Content>
          <Input.Root>
            <Input.Label>Vaga</Input.Label>
            <Select.Root>
              <Select.Search options={jobs || []} value={filters} setValue={setFilters} field="positionName" />
            </Select.Root>
          </Input.Root>
        </Column.Content>
      </Column.Root>
      <Column.Root>
        <Column.Content>
          <div className="box mt-4 has-text-centered">
            <p className="subtitle is-size-4 mb-1">
              {reportStatusPerJobOfferTotal.checkins_realizados_totais}
              <span className="has-text-grey is-size-6">
                / {reportStatusPerJobOfferTotal.total_staff_participantes}
              </span>
            </p>

            <div className="is-flex is-justify-content-center is-align-items-center mt-2">
              <span className="icon has-text-grey mr-3">
                <Icon size={18}>checkin</Icon>
              </span>
              <span className="is-size-5 has-text-grey">Check-in</span>
            </div>
          </div>
        </Column.Content>
        <Column.Content>
          <div className="box mt-4 has-text-centered">
            <p className="subtitle is-size-4 mb-1">
              {reportStatusPerJobOfferTotal.checkouts_realizados_totais}
              <span className="has-text-grey is-size-6">
                / {reportStatusPerJobOfferTotal.total_staff_participantes}
              </span>
            </p>
            <div className="is-flex is-justify-content-center is-align-items-center mt-2">
              <span className="icon has-text-grey mr-3">
                <Icon size={18}>checkout</Icon>
              </span>
              <span className="is-size-5 has-text-grey">Check-out</span>
            </div>
          </div>
        </Column.Content>
        <Column.Content>
          <div className="box mt-4 has-text-centered">
            <p className="subtitle is-size-4 mb-1">{reportStatusPerJobOfferTotal.total_staff}</p>
            <div className="is-flex is-justify-content-center is-align-items-center mt-2">
              <span className="icon has-text-grey mr-3">
                <Icon size={18}>users</Icon>
              </span>
              <span className="is-size-5 has-text-grey">Staff Total</span>
            </div>
          </div>
        </Column.Content>
      </Column.Root>
      <Column.Root className="pr-2 pl-2">
        <Column.Content className="box" style={{ padding: 30 }}>
          <Input.Label>Contagem total Situação x Vaga</Input.Label>
          <div className="table-container">
            <table
              className="table is-striped is-hoverable is-fullwidth is-size-7 is-bordered"
              style={{ tableLayout: 'fixed', width: '100%' }}
            >
              <thead>
                <tr>
                  <th className="has-text-weight-bold" style={{ width: '20%' }}>
                    Situação
                  </th>
                  {(reportStatusPerJobOffer || []).map((row) => (
                    <th
                      className="has-text-weight-bold has-text-centered"
                      key={row.jobOffer}
                      style={{ width: `${60 / (reportStatusPerJobOffer.length || 1)}%` }}
                    >
                      {row.jobOffer}
                    </th>
                  ))}
                  <th className="has-text-weight-bold has-text-centered" style={{ width: '20%' }}>
                    Total
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.keys(statusStaff)
                  .filter(
                    (status) =>
                      ![
                        'cancelados_recusas_desistencias_totais',
                        'checkins_realizados_totais',
                        'checkouts_realizados_totais',
                        'total_staff_participantes',
                        'total_staff',
                      ].includes(status),
                  )
                  .map((status) => {
                    const totalPorStatus = (reportStatusPerJobOffer || []).reduce(
                      (sum, row) => sum + (row[status] || 0),
                      0,
                    )

                    return (
                      <tr key={status}>
                        <td className="has-text-weight-semibold has-text-left">
                          {TransformationforMask(status.replaceAll('_', ' '), 'title')}
                        </td>
                        {(reportStatusPerJobOffer || []).map((row) => (
                          <td key={row.jobOffer} className="has-text-centered">
                            {row[status] ?? 0}
                          </td>
                        ))}
                        <td className="has-text-weight-bold has-text-centered">{totalPorStatus}</td>
                      </tr>
                    )
                  })}
              </tbody>
            </table>
          </div>
        </Column.Content>
      </Column.Root>
      <div style={{ flexDirection: 'row', display: 'flex' }}></div>
    </Page.Section>
  )
}
